<div *ngIf="( isLoading | async )">
  <div class="loader-overlay">
    <mat-spinner>
    </mat-spinner>
  </div>
</div>
